import { useQuery } from '@tanstack/react-query'
import { fetchMove } from '@/api/moves'
import { movesKeys } from '@/api/queryKeys'

/**
 * Hook to fetch a single move by ID
 *
 * @param moveId - The UUID of the move to fetch
 * @param includeRelations - Include related entities (taggings, series)
 * @returns React Query result with move data, loading state, and error
 *
 * @example
 * ```tsx
 * const { data: move, isLoading, isError, error, refetch } = useMove('move-123', true)
 * ```
 */
export function useMove(moveId: string, includeRelations = true) {
  return useQuery({
    queryKey: [...movesKeys.detail(moveId), { includeRelations }] as const,
    queryFn: () => fetchMove(moveId, includeRelations),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!moveId,
  })
}
